fragment UserQuotaFragment on User {
    id
    name
    avatarUrl
    initials
    teams {
        id
        name
    }
    quotas {
        fiscalYear
        months {
            identifier
            value {
                amount
            }
        }
    }
}
